import { MouseEvent, useState } from 'react'

import { Button, Icon, Spinner, Tooltip, TooltipContent, TooltipTrigger } from '@forto-dev/phoenix-ui-core'

import { isShipmentId } from '../../../utils/entityId'
import { useLocalisation } from '../../../utils/localisation'
import { useBookmark } from '../hooks/useBookmark'

type BookmarkProps = {
  entityId: string
}

export const Bookmark = ({ entityId }: BookmarkProps) => {
  const { translate } = useLocalisation()
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const {
    deleteBookingBookmark,
    createBookingBookmark,
    deleteShipmentBookmark,
    createShipmentBookmark,
    bookmarkedShipmentIds,
    bookmarkedBookingIds,
  } = useBookmark()

  const isShipment = isShipmentId(entityId)
  const isBookmarked = bookmarkedShipmentIds?.includes(entityId) || bookmarkedBookingIds?.includes(entityId)

  const handleToggleBookmark = async (event: MouseEvent) => {
    event.preventDefault()
    setIsLoading(true)
    if (isShipment) {
      if (isBookmarked) {
        await deleteShipmentBookmark(entityId)
      } else {
        await createShipmentBookmark(entityId)
      }
    } else {
      if (isBookmarked) {
        await deleteBookingBookmark(entityId)
      } else {
        await createBookingBookmark(entityId)
      }
    }
    setIsLoading(false)
  }

  const actionText = isBookmarked ? translate('shipment.bookmark.remove') : translate('shipment.bookmark.add')
  return (
    <Tooltip>
      <TooltipTrigger>
        <Button
          variant={isBookmarked ? 'outline-primary' : 'outline-secondary'}
          size="icon"
          onClick={handleToggleBookmark}
        >
          {isLoading ? (
            <Spinner size="sm" color="primary" />
          ) : (
            <Icon name="Bookmark" color={isBookmarked ? 'primary' : 'inherit'} size="sm" />
          )}
        </Button>
      </TooltipTrigger>
      <TooltipContent>{actionText}</TooltipContent>
    </Tooltip>
  )
}
